import React, { Component } from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';
import Description from '../descriptionTab/description';
import Specifications from '../specificationTab/specifications';
import Return from '../deliveryAndReturn/delAndRet';
import PaymentOptions from '../paymentsTab/PaymentOptions';
import Stock from '../../stock/stockStatus';
import * as actions from '../tabActions';
import './tabStyle.less';
import BreadcrumbsNew from '../../breadcrumbs/BreadcrumbsNew';
import scrollTo from '../../../../utils/scrollTo';

class Tabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabElements: [
        {
          element: <Description />,
          translation: t`Product description`,
          name: 'Product description'
        },
        {
          element: <Specifications />,
          translation: t`Specifications`,
          name: 'Specifications'
        },
        {
          element: <Return />,
          translation: t`Delivery and returns`,
          name: 'Delivery and returns'
        },
        {
          element: <PaymentOptions />,
          translation: t`Payment options`,
          name: 'Payment options'
        }
      ]
    };
  }

  componentDidMount() {
    const { language } = this.props;
    const { description, intro_text } = this.props.app.data;
    const { tabElements } = this.state;
    // add Flagship stock if it's Denmark, France, Norway or Sweden.
    if (['da', 'fr', 'nb', 'sv'].includes(language)) {
      const newTabElements = tabElements;
      newTabElements.push({
        element: <Stock />,
        translation: t`Stock status in the store`,
        name: 'Stock status in the store'
      });
      this.setState({
        tabElements: newTabElements
      });
    }
    // remove Description if the product doesn't have any
    if (description.length < 10 && intro_text.length < 10) {
      const noDescription = tabElements;
      noDescription.shift();
      this.setState({
        tabElements: noDescription
      });
      this.props.POPULATE_TAB_DESKTOP('Specifications', 0);
    } else {
      this.props.POPULATE_TAB_DESKTOP('Product description', 0);
    }

    setTimeout(() => {
      scrollTo(() =>
        this.props.POPULATE_TAB_DESKTOP('Stock status in the store', 4)
      );
    }, 1000);
  }

  render() {
    const { activeTab, activeTabIndex } = this.props.tabs;
    const { tabElements } = this.state;
    const { breadcrumbs } = window.__INITIAL_STATE__;
    return (
      <div className="tabWrapper">
        <div className="tabGroup" id="stock">
          {tabElements.map((tab, i) => {
            return (
              <div
                className={
                  activeTab === tab.name ? 'tabItem active' : 'tabItem'
                }
                key={tab.name}
                onClick={() => this.props.POPULATE_TAB_DESKTOP(tab.name, i)}
                role="button"
                tabIndex="0"
                style={{ outline: 'none' }}
              >
                <div className="nav-item-inner">
                  <div className="tabHeader">{tab.translation}</div>
                </div>
                <span className="t-bar" />
              </div>
            );
          })}
        </div>
        <div className="tabContent">
          {tabElements[activeTabIndex]
            ? tabElements[activeTabIndex].element
            : tabElements[0].element}
          {breadcrumbs.length > 0 && <hr />}
          <BreadcrumbsNew
            breadcrumbs={breadcrumbs}
            position="bottom"
            expandable={false}
            sidePadding
          />
          {breadcrumbs.length > 0 && <hr />}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ app, tabs, general }) => {
  return {
    app,
    tabs,
    language: general.language
  };
};

export default connect(mapStateToProps, actions)(Tabs);
